/// <reference path="../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as Rest from "../../Generated/RestClient";
import {BotImageControl} from "../../../../Intercom.ReactUI/Views/BotImageControl";
import {clientAppSettings} from "../../Models/ClientAppSettings";
import {IconFile} from "./BotPage";
import Dropzone = require("react-dropzone")

export interface BotIconControlProps extends React.Props<BotIconControl> {
    bot: Rest.BotService;
    onDropIcon(files: IconFile[]): void;
}

export interface BotIconControlState {
}

export class BotIconControl extends React.Component<BotIconControlProps, BotIconControlState> {
    private iconTile: HTMLDivElement;

    private onUploadLinkClick() {
        if (this.iconTile) {
            $(this.iconTile).find('input[type="file"]').trigger('click');
        }
    }

    public render(): JSX.Element {
        return (
            <div className="icon-tile" ref={ x => this.iconTile = x}>
                <div className="icon-tile-lhs">
                    <Dropzone ref="iconDrop"
                        className="icon-upload"
                        multiple={false}
                        accept="image/png"
                        onDrop={(files) => this.props.onDropIcon(files) }>
                        <BotImageControl bot={this.props.bot}
                            defaultIconUrl={clientAppSettings.defaultIconUrl}/>
                    </Dropzone>
                    <input ref="agent-icon-url" type="hidden" id="agent-icon-url"
                        value={this.props.bot.IconUrl}/>
                    <input ref="agent-icon-default-hash" type="hidden" id="agent-icon-default-hash"
                        value={this.props.bot.DefaultIconColorHash}/>
                </div>
                <div className="icon-tile-rhs">
                    <div className="icon-tile-title">Icon</div>
                    <a href="javascript:void(0)" className="icon-upload-link" onClick={x => this.onUploadLinkClick()}>Upload custom icon</a>
                    <span>30K max, png only</span>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./Client/v4/Views/BotIconControl.tsx